var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fancy-header d-flex flex-column align-items-center py-4 px-4"},[_c('img',{staticClass:"background-img",attrs:{"src":_vm.backgroundSrc}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }